import type { KpiDelta as KpiDeltaSchema } from "@acto/genui-components-schema";
import {
  Card,
  Footer,
  FooterCol,
  FooterValue,
  Header,
  CardHeadline,
  MetaLabel,
} from "@acto/taskpane/field-sales-2/components/primitives/Card";
import { Divider } from "@acto/taskpane/field-sales-2/components/primitives/Divider";
import { SentimentColor } from "./SentimentColor";

interface KpiDeltaProps {
  part: KpiDeltaSchema;
}

export function KpiDelta({ part }: KpiDeltaProps) {
  return (
    <Card>
      <Header>
        <MetaLabel>{part.metricLabel}</MetaLabel>
        <CardHeadline>
          <SentimentColor sentiment={part.sentiment ?? "neutral"}>{part.value}</SentimentColor>
        </CardHeadline>
      </Header>
      <Divider />
      <Footer>
        <FooterCol>
          <MetaLabel>{part.baseline.label}</MetaLabel>
          <FooterValue>{part.baseline.value}</FooterValue>
        </FooterCol>
        {part.delta && (
          <FooterCol>
            <MetaLabel>{part.delta.label}</MetaLabel>
            <FooterValue>{part.delta.value}</FooterValue>
          </FooterCol>
        )}
      </Footer>
    </Card>
  );
}
